<template>
  <main class="grid gap-4 md:px-4">
    <img :src="offerImageUrl" alt="Offer Image" class="w-full" />
    <article
      v-for="(offerContent, index) in offerDetail.offerDetails"
      :key="index"
      class
    >
      <h2 class="font-semibold">{{ offerContent.headerDisplayText }}</h2>
      <ul class="list-square text-sm list-inside">
        <li v-for="(detail, index) in offerContent.details" :key="index">
          {{ detail }}
        </li>
      </ul>
    </article>
    <a
      :href="offerDetail?.redirectUrl"
      class="btn btn--primary btn--normal justify-self-center"
      target="_blank"
      v-if="offerDetail.actionText"
      >{{ offerDetail.actionText }}</a
    >
  </main>
</template>
<script>
export default {
  name: 'OfferDetails',
  data() {
    return {
      offerDetail: undefined,
    };
  },
  mounted() {
    this.init();
  },
  computed: {
    offerImageUrl() {
      if (this.offerDetail?.carouselOffers?.webUrl) {
        return this.offerDetail?.carouselOffers?.webUrl;
      }
      if (this.offerDetail?.carouselHome?.webUrl) {
        return this.offerDetail?.carouselHome?.webUrl;
      }
      return this.offerDetail?.topOffers?.webUrl;
    },
  },
  methods: {
    init() {
      this.offerDetail = JSON.parse(this.$route.query.offerDetail);
      if (!this.offerDetail) {
        this.$route.push({ name: 'Offers' });
      }
    },
  },
};
</script>
